import MagazineFilter from "./MagazineFilter";

const { register } = require("@lpm/pug-components/dist/register");

register("MagazineFilter/MagazineFilter", MagazineFilter);